<script setup lang="ts">
import { ImageMedia } from '@clovyr/bed';
import FroggyTwig from '@clovyr/bed/assets/images/froggy-twig.webp';
import Button from '@clovyr/bed/components/controls/Button.vue';
</script>

<template>
  <div class="page page-not-found">
    <div class="container">
      <div class="row">
        <div class="grid__col-md-6 column-content">
          <h1 class="title">Page not found.</h1>

          <p>Whoops... the page you’re looking for doesn’t exist.</p>

          <Button link="/" reversed label="Return to the Garden"></Button>
        </div>

        <div class="grid__col-md-6 column-graphic">
          <ImageMedia class="not-found-graphic" :filename="FroggyTwig" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/layout/grid-vars';
@use 'styles/core/typography/fonts';
@use 'styles/vendor/bootstrap/scss/mixins/breakpoints';

.page {
  &.page-not-found {
    @include breakpoints.media-breakpoint-up(md) {
      padding-left: var(--col-gutter-outer-left);
    }

    .container {
      .row {
        align-items: center;
        display: flex;
        height: 100vh;
        position: relative;
        overflow: hidden;

        .column-content {
          align-items: center;
          display: flex;
          flex-direction: column;
          position: relative;
          z-index: 1;

          @include breakpoints.media-breakpoint-up(md) {
            align-items: flex-start;
          }

          .title {
            @include fonts.font-size(32);

            @include breakpoints.media-breakpoint-up(md) {
              @include fonts.font-size(42);
            }

            @include breakpoints.media-breakpoint-up(xl) {
              @include fonts.font-size(67);
            }
          }

          p {
            @include fonts.font-size(16);

            margin-top: grid-vars.space(2);
            margin-bottom: grid-vars.space(3);

            @include breakpoints.media-breakpoint-up(md) {
              margin-top: grid-vars.space(3);
              margin-bottom: grid-vars.space(5);
            }

            @include breakpoints.media-breakpoint-up(xl) {
              @include fonts.font-size(19);
            }
          }
        }

        .column-graphic {
          position: absolute;
          right: -5%;
          top: -5%;
          width: 50%;

          @include breakpoints.media-breakpoint-up(md) {
            padding-right: 0;
            position: static;
          }
        }

        .not-found-graphic {
          height: 100vh;
          overflow: hidden;

          :deep(img) {
            height: 100%;
            object-fit: contain;

            @include breakpoints.media-breakpoint-up(md) {
              object-position: grid-vars.space(2) grid-vars.space(18);
            }
          }
        }
      }
    }
  }
}
</style>
